export const CONTRACT_TRADING = {
    TRADING: '0xB47ac7722D40a41a50e2ff3deD1B377d2da2a123',
    TRADING_STORE: '0x441b81f9ACeBEc2C855E8DbDaA82967fEa185169',
    PAIR_INFOS: '0xe620A1F019eEA4AD23FFA987f58Cc43913325274',
};

export const FEES: Record<string, number> = {
    crypto: 0.08,

    forex: 0.016,

    commodities: 0.02,
    'commodities-1': 0.02,
    stock: 0.1,
};
